module.exports = __webpack_public_path__ + "img/pro_capture14.4910e031.png";